import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DownloadService {
    delay = (milliseconds) =>
        new Promise((resolve) => {
            setTimeout(resolve, milliseconds);
        });

    async downloadFile(link: string): Promise<void> {
        const downloadLink = document.createElement('a');
        downloadLink.style.display = 'none';

        document.body.appendChild(downloadLink);

        const download = link;
        downloadLink.id = `url-${link}`;
        downloadLink.setAttribute('href', download);
        downloadLink.setAttribute('download', download);

        await downloadLink.click();
        await this.delay(1000);

        document.body.removeChild(downloadLink);
    }
}
